import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import {
  ShareableType,
  BdSharePermission,
} from '@bindoc-projects/resource-domain-lib';
import { BdShareablesService } from '../core/resources.service';

@Component({
    selector: 'bd-permissions-resources-checker',
    template: `
    @if (hasPermission()) {
      <ng-content></ng-content>
    }
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class BdPermissionsResourcesCheckerComponent {
  readonly resourceName = input<ShareableType>();
  readonly resourceId = input<string>();
  readonly permission = input<BdSharePermission>();

  public readonly hasPermission = signal(false);

  private readonly _resourcePermissionService = inject(BdShareablesService);

  constructor() {
    effect(() => {
      const resourceId = this.resourceId();
      const resourceName = this.resourceName();
      const permission = this.permission();
      this._checkPermission(resourceName, resourceId, permission);
    });
  }

  private _checkPermission(
    resourceName: ShareableType | undefined,
    resourceId: string | undefined,
    permission: BdSharePermission | undefined,
  ): void {
    if (resourceId && resourceName && permission) {
      this._resourcePermissionService
        .hasPermission(resourceName, resourceId, permission)
        .then((hasPermission) => {
          this.hasPermission.set(hasPermission);
        })
        .catch(() => {
          this.hasPermission.set(false);
        });
    }
  }
}
